import React from 'react';
import styled, { withTheme } from 'styled-components';
import ReactModal from 'react-modal';
import theme from '../../../../ui/theme';
import ModalCloseIconSvg from '../../../svgs/ModalCloseIconSvg';
import { trackAnalytics, toSlug } from '../../../../lib/utils';
import { DOM_MODAL } from '../../../../lib/constants';

const ModalContainerDiv = styled.div`
  z-index: ${p => p.theme.elevation[3]};
`;

const ModalContainer = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  background-color: transparent;
`;

const CloseButtonRowBackgroundDiv = styled.div`
  background: transparent;
`;

const CloseButtonRowDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: nowrap;
  margin: ${p => p.theme.unit(0.75)};
  
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  padding: ${p => p.theme.unit(0.5)} ${p => p.theme.unit(1)};
  ${(p) => p.theme.typographyRebrand.body.md}
  cursor: pointer;
  display: flex;
  flex-direction: row;
  color: ${p => p.theme.c.text.invert};
`;

const desktopStyles = {
  content: {
    position: 'relative',
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto',
    inset: 'auto',
    border: 'none',
    background: 'transparent',
    outline: 'none',
    borderRadius: '0',
    padding: '0',
    maxHeight: '100vh',
  },
  overlay: {
    right: 'auto',
    bottom: 'auto',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.c.overlay.background,
    backdropFilter: 'blur(4px)',
    zIndex: `${theme.elevation[3]}`,
  },
};

const mobileStyles = {
  content: {
    top: `${theme.custom.HEADER_HEIGHT_MOBILE}px`,
    left: '0',
    right: 'auto',
    bottom: 'auto',
    border: 'none',
    borderRadius: '0',
    width: '100%',
    height: '100vh',
    overflow: 'scroll',
    boxSizing: 'border-box',
    padding: '0px 0px 60px 0px',
  },
  overlay: {
    backgroundColor: theme.c.overlay.background,
    backdropFilter: 'blur(4px)',
    zIndex: `${theme.elevation[3]}`,
  },
};

export const CloseButtonIcon = withTheme((props) => {
  const {
    theme,
    title = 'Close',
  } = props;

  return (<ModalCloseIconSvg fill={theme.c.icon.invert} title={title} />);
});

class Modal extends React.Component {
  constructor() {
    super();

    this.state = {
      body: null,
      isMobile: false,
      showClose: true,
      styles: {
        desktop: { content: {}, overlay: {} },
        mobile: { content: {}, overlay: {} },
      },
    };

    this.closeModal = this.closeModal.bind(this);
    this.updateModalBody = this.updateModalBody.bind(this);
  }

  updateModalBody(
    body,
    isMobile,
    styles = {
      desktop: { content: {}, overlay: {} },
      mobile: { content: {}, overlay: {} },
    },
    showClose = true) {

    this.setState({
      body,
      isMobile,
      styles,
      showClose,
    });
  }

  closeModal() {
    const {
      urlQueryParams = {},
    } = this.props;

    const {
      affiliateUrl,
      externalRedirectUrl,
    } = urlQueryParams;

    if (affiliateUrl || externalRedirectUrl) {
      window.close();
    }

    this.setState({
      body: null,
      isMobile: false,
    });
  }

  render() {
    const {
      contentLabel = '', // TODO: accescibility for title of modal
      modalCloseButtonText, // source from globalPageConfig
      modalCloseButtonTagSet, // source from globalPageConfig
    } = this.props;

    const isOpen = !!this.state.body;

    const stylesToUse = {
      content: { ...desktopStyles.content, ...this.state.styles.desktop.content },
      overlay: { ...desktopStyles.overlay, ...this.state.styles.desktop.overlay },
    };

    if (this.state.isMobile) {
      stylesToUse.content = { ...mobileStyles.content, ...this.state.styles.mobile.content };
      stylesToUse.overlay = { ...mobileStyles.overlay, ...this.state.styles.mobile.overlay };
    }

    const track = trackAnalytics(DOM_MODAL, toSlug(modalCloseButtonText), '', modalCloseButtonTagSet);

    const CloseButtonComp = (isMobile) => {
      return (
        <CloseButtonRowBackgroundDiv isMobile={isMobile}>
          <CloseButtonRowDiv>
            <CloseButton
              isMobile={isMobile}
              onClick={this.closeModal}
              id={track.dataTrackingId}
              data-track-id={track.dataTrackingId}
              data-track-click={track.dataTrack}>
              {modalCloseButtonText}
              <CloseButtonIcon title={modalCloseButtonText} />
            </CloseButton>
          </CloseButtonRowDiv>
        </CloseButtonRowBackgroundDiv>
      );
    };

    return (
      <ModalContainerDiv>

        <ReactModal
          ariaHideApp={false}
          isOpen={isOpen}
          onRequestClose={this.closeModal}
          style={stylesToUse}
          contentLabel={contentLabel} >
          <ModalContainer>
            { this.state.showClose ? CloseButtonComp(this.state.isMobile) : null }
            { this.state.body }
          </ModalContainer>
        </ReactModal>

      </ModalContainerDiv>
    );
  }
}

export default Modal;
